import statsig from 'xAppLib/providers/statsig'

// Routes where the mvr discount is allowed to override prs_mc.mc_std.
// prs_mc.mc_std is a single shared price key read by many unrelated pages/components,
// so applying the discount must be scoped to these paths rather than global.
const MVR_DISCOUNT_PATHS = [
	'/online-medical-certificates',
	'/c/pharm/certs',
	'/m/pharm/certs',
];

export function is_mvr_discount_path(pathname) {
	return MVR_DISCOUNT_PATHS.some(p => pathname === p || pathname.startsWith(`${p}/`));
}

// Phase 1: URL based price test
const STORAGE_KEY = 'mvr_discount';
const DISCOUNT_TTL_MS = 24 * 60 * 60 * 1000; // 1 day

export const MVR_DISCOUNTS = [
	{ code: '74hfg', price: 12.90 },
	{ code: 'h378s', price: 19 },
];

export function persist_mvr_discount(get_params_init) {
	try {
		const code = get_params_init?.get('mvr');
		if (!MVR_DISCOUNTS.some(d => d.code === code))
			return;
		const saved = app.localStorage[STORAGE_KEY] || [];
		const others = saved.filter(d => d.code !== code);
		app.localStorage[STORAGE_KEY] = [...others, {
			code: code,
			expiry: Date.now() + DISCOUNT_TTL_MS,
			params: Object.fromEntries(get_params_init),
		}];
	} catch (e) { }
}

export function get_active_mvr_discount(pathname) {
	if (!is_mvr_discount_path(pathname))
		return null;
	try {
		const saved = app.localStorage[STORAGE_KEY];
		if (!saved)
			return null;
		const active = saved.filter(d => Date.now() < d.expiry).pop(); // latest landed code wins
		if (!active)
			return null;
		const discount = MVR_DISCOUNTS.find(d => d.code === active.code);
		if (!discount)
			return null;
		return {
			price: discount.price,
			expiry: active.expiry,
			mvr_origin_params: active.params,
		};
	} catch (e) {
		return null;
	}
}

// Phase 2: Statsig based price test
export const PRICE_EXPRM_KEY = 'Onsite_price_test_Oct_26'

const PRICE_BY_VARIANT = {
	n: 19,    // normal
	m: 14.90, // medium
	c: 12.90, // cheap
}

export function get_active_price_exprm(pathname) {
	if (!is_mvr_discount_path(pathname))
		return null;
	if (get_active_mvr_discount(pathname)) // mvr discount takes priority
		return null;
	try {
		const variant = statsig.get_assignments([PRICE_EXPRM_KEY])[PRICE_EXPRM_KEY] ?? null
		const price = PRICE_BY_VARIANT[variant]
		if (price === undefined)
			return null

		return { variant, price };
	} catch (e) {
		return null;
	}
}
